import React, { Component } from "react";
import $ from "jquery";
import PdfViewer from "./PdfViewer";
import moment from "moment";
import StandardSelectModal from "./StandardSelectModal";
import SuggestionsList from "./SuggestionsList";

class ReportCreditWalletModal extends Component {
    //#region Component Actions
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                branchCode: "---",
                pkSucursal: '',
                salesPerson: false,
                salesPersonArray: [],
                groupNum: false,
                groupNumArray: [],
                // dateStart: moment().format("YYYY-MM-DD"),
                // dateEnd: moment().format("YYYY-MM-DD"),
                dateStart: '',
                dateEnd: '',
                cardCode: "---",
                businessPartner: "",
            },
            branchOffices: [],

            showBPSuggestion: false,
            businessParterSuggestions: [],

            showSalesPersonModal: false,
            showGroupNumModal: false,
            showSelectBPModal: false,
        };
        this.businessParterInput = React.createRef();
    }

    componentDidMount() {
        const modalContent = document.getElementById('ReportCreditWallet');
        if (modalContent) { modalContent.addEventListener('scroll', () => this.setState({ showBPSuggestion: false, businessParterSuggestions: [] })); }

        const { branchOffices = [] } = this.props;
        if (branchOffices.length > 0) {
            this.setState({ branchOffices: branchOffices.sort((a, b) => a.project.toLowerCase().localeCompare(b.project.toLowerCase())) });
        }
    }

    close() {
        $("#ReportCreditWallet").modal("hide");
    }
    //#endregion

    //#region Open Selection Modals
    openSalesPersonModal = async () => {
        await this.setState({ showSalesPersonModal: true });
        $("#selectSalesPersonModal").modal("show");
        $("#selectSalesPersonModal").on("hidden.bs.modal", async () => {
            await this.setState({ showSalesPersonModal: false });
        });
    }

    openGroupNumModal = async () => {
        await this.setState({ showGroupNumModal: true });
        $("#selectGroupNumModal").modal("show");
        $("#selectGroupNumModal").on("hidden.bs.modal", async () => {
            await this.setState({ showGroupNumModal: false });
        });
    }

    openBusinessPartnerModal = async () => {
        await this.setState({ showSelectBPModal: true });
        $("#selectBPModal").modal("show");
        $("#selectBPModal").on("hidden.bs.modal", async () => {
            await this.setState({ showSelectBPModal: false });
        });
    }
    //#endregion

    //#region Update Filters
    updateField = (field = "", value = "") => {
        const { branchOffices } = this.props
        let { filters } = this.state;
        filters[field] = value;
        if (field === 'pkSucursal') {
            const findBO = branchOffices.find((sucursal) => Number(sucursal.pk_Sucursal) === Number(value))
            if (findBO !== undefined) filters["branchCode"] = findBO.project ?? '';
        }
        this.setState({ filters });
    }

    updateBP = (value = "") => {
        const { suggestionCatalogs: { businessPartnerCCatalog } } = this.props;
        let { filters } = this.state;
        filters.businessPartner = value;
        filters.cardCode = "---";

        let businessParterSuggestions = [];

        if (value.trim() !== "") {
            const searchTokens = value.toLowerCase().split(" ");
            businessParterSuggestions = businessPartnerCCatalog.filter(record => {
                const tokens = (record?.CardCode + " " + record?.CardName + " " + record?.LicTradNum).toLowerCase().split(" ");
                return searchTokens.every(token => tokens.some(itemToken => itemToken.includes(token))
                )
            }).slice(0, 15);
        }

        const showBPSuggestion = businessParterSuggestions.length > 0;
        this.setState({ filters, businessParterSuggestions, showBPSuggestion });
    }

    selectBP = (businessParter) => {
        let { filters } = this.state;
        filters.businessPartner = businessParter.CardName;
        filters.cardCode = businessParter.CardCode;
        this.setState({ filters, businessParterSuggestions: [], showBPSuggestion: false });
        $("#selectBPModal").modal("hide");
    }
    //#endregion

    render() {
        const {
            suggestionCatalogs: {
                businessPartnerCCatalog = [],
                salesPersonCatalog = [],
                groupNumCatalog = [],
            },

            // Standard Props
            ListReports,
            GenerateReport,
            ShowPDFViewerModal,
            ShowPDFViewer,
            ReportsModel,
            MailTools,
            printhide,
            ShowFormatToPrint,
        } = this.props;
        const {
            filters: {
                branchCode,
                pkSucursal,
                salesPerson,
                salesPersonArray,
                groupNum,
                groupNumArray,
                dateStart,
                dateEnd,
                businessPartner,
            },
            branchOffices,

            showBPSuggestion,
            businessParterSuggestions,

            showSalesPersonModal,
            showGroupNumModal,
            showSelectBPModal,
        } = this.state;

        let inputBPRect = { width: 0, height: 0, top: 0, left: 0, bottom: 0, right: 0 };
        if (this.businessParterInput.current) inputBPRect = this.businessParterInput.current.getBoundingClientRect();

        return (
            <div>
                <div id="ReportCreditWallet" className="modal fade bd-example-modal-lg">
                    <div id="ReportCreditWalletContent" className="modal-dialog modal-dialog-centered modal-md" role="document" >
                        <div className="modal-content">
                            <div className="modal-header text-white" style={{ backgroundColor: "#343a40", borderRadius: "0" }}>
                                <h4 className="modal-title" id="modal-basic-title "> Reporte de Cartera de Crédito</h4>
                                <button type="button" className="close" onClick={this.close} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="row mt-3">
                                    <div className="col-12 input-group mb-3">
                                        <div className="input-group-prepend">
                                            <label className="input-group-text font-weight-bold" htmlFor="selectBranch"> Sucursal </label>
                                        </div>
                                        <select
                                            id="selectBranch"
                                            className="form-control"
                                            value={pkSucursal} // branchCode
                                            onChange={({ target: { value } }) => { this.updateField("pkSucursal", value) }} >
                                            <option value="---"> Selecciona </option>
                                            {branchOffices.map(branch => <option value={branch.pk_Sucursal}> {branch.project} - {branch.nombre} </option>)}
                                        </select>
                                    </div>
                                    <div className="col-12 input-group mb-3">
                                        <div className="input-group-prepend input-group-text">
                                            <input
                                                id="cbSalesPerson"
                                                className="font-weight-bold"
                                                type="checkbox"
                                                checked={salesPerson}
                                                onChange={() => this.updateField("salesPerson", !salesPerson)} />
                                        </div>
                                        <label className="form-control" htmlFor="cbSalesPerson"> Vendedor </label>
                                        <div className="input-group-prepend">
                                            <button className="btn btn-outline-warning rounded-right" onClick={this.openSalesPersonModal}> <i className="fa fa-list" /> </button>
                                        </div>
                                    </div>
                                    <div className="col-12 input-group mb-3">
                                        <div className="input-group-prepend input-group-text">
                                            <input
                                                id="cbGroupNum"
                                                type="checkbox"
                                                checked={groupNum}
                                                onChange={() => this.updateField("groupNum", !groupNum)} />
                                        </div>
                                        <label className="form-control" htmlFor="cbGroupNum"> Condiciones de pago </label>
                                        <div className="input-group-prepend">
                                            <button className="btn btn-outline-warning rounded-right" onClick={this.openGroupNumModal}> <i className="fa fa-list" /> </button>
                                        </div>
                                    </div>
                                    {/* isra told me that dates params start at specif date to today */}
                                    {/* <div className="col-12 col-md-6 input-group mb-3">
                                        <div className="input-group-prepend">
                                            <label className="input-group-text font-weight-bold" htmlFor="dateStart"> Desde </label>
                                        </div>
                                        <input
                                            id="dateStart"
                                            className="form-control"
                                            type="date"
                                            value={dateStart}
                                            onChange={({ target: { value } }) => this.updateField("dateStart", value)} />
                                    </div>
                                    <div className="col-12 col-md-6 input-group mb-3">
                                        <div className="input-group-prepend">
                                            <label className="input-group-text font-weight-bold" htmlFor="dateEnd"> Hasta </label>
                                        </div>
                                        <input
                                            id="dateEnd"
                                            className="form-control"
                                            type="date"
                                            value={dateEnd}
                                            onChange={({ target: { value } }) => this.updateField("dateEnd", value)} />
                                    </div> */}
                                    <div className="col-12 input-group mb-3">
                                        <div className="input-group-prepend ">
                                            <label className="input-group-text font-weight-bold" htmlFor="txtBusinessPartner"> Cliente </label>
                                        </div>
                                        <input
                                            ref={this.businessParterInput}
                                            id="txtBusinessPartner"
                                            className="form-control"
                                            type="text"
                                            autoComplete="off"
                                            value={businessPartner}
                                            onChange={({ target: { value } }) => this.updateBP(value)}
                                            onBlur={() => this.setState({ businessParterSuggestions: [], showBPSuggestion: false })} />
                                        <div className="input-group-prepend">
                                            <button className="btn btn-outline-warning rounded-right" onClick={this.openBusinessPartnerModal}> <i className="fa fa-list" /> </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.close}>Cerrar</button>
                                <button type="button" className="btn btn-primary" onClick={() => GenerateReport(this.state.filters)}>Generar</button>
                            </div>
                        </div>
                    </div>

                    {showBPSuggestion &&
                        <SuggestionsList
                            suggestions={businessParterSuggestions}
                            keys={[
                                { field: "CardCode", classes: "key", styles: { minWidth: 75, maxWidth: 75 } },
                                { field: "CardName", classes: "", styles: { minWidth: inputBPRect.width - 100, maxWidth: inputBPRect.width - 100 } },
                            ]}
                            action={this.selectBP}
                            styles={{ maxHeight: 200 }}
                            rect={inputBPRect} />
                    }
                </div>

                {showSalesPersonModal &&
                    <StandardSelectModal
                        id="selectSalesPersonModal"
                        title="Vendedores"
                        data={salesPersonCatalog}
                        selectAction={(data) => this.updateField("salesPersonArray", data)}
                        selectedItems={salesPersonArray}

                        headers={[
                            { title: "Codigo", value: true, filter: true, field: "Code", format: null, classes: "text-left" },
                            { title: "Empleado", value: true, filter: true, field: "Name", format: null, classes: "text-left" },
                        ]}

                        actPos="start"
                        selection="multiple"
                        idSelection="SlpCode"
                        warningQtySelection={50}
                        limitQtySelection={100}
                        validNoSelection={true} />
                }

                {showGroupNumModal &&
                    <StandardSelectModal
                        id="selectGroupNumModal"
                        title="Condiciones de pago"
                        data={groupNumCatalog}
                        selectAction={(data) => this.updateField("groupNumArray", data)}
                        selectedItems={groupNumArray}

                        headers={[
                            { title: "Condición", value: true, filter: true, field: "Name", format: null, classes: "text-left" },
                        ]}

                        actPos="start"
                        selection="multiple"
                        idSelection="Code"
                        warningQtySelection={50}
                        limitQtySelection={100}
                        validNoSelection={true}
                    />
                }

                {showSelectBPModal &&
                    <StandardSelectModal
                        id="selectBPModal"
                        title="Clientes"
                        data={businessPartnerCCatalog}
                        selectAction={this.selectBP}
                        searchBar={businessPartner}

                        headers={[
                            { title: "Código", value: true, filter: true, field: "CardCode", format: null, classes: "text-left" },
                            { title: "Cliente", value: true, filter: true, field: "CardName", format: null, classes: "text-left" },
                            { title: "RUT", value: false, filter: true, field: "LicTradNum", format: null, classes: "text-left" },
                        ]}

                        actPos="start" />
                }

                {ShowPDFViewerModal &&
                    <PdfViewer
                        DocsToPrint={ListReports}
                        TypeDoc={"ReportCreditWallet"}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={false}
                        EditableDocModel={"SalesTools.EditableDocModel"}
                        RefreshDocModel={"SalesTools.RefreshDocModel"}
                        SaveChanges={"SalesTools.SaveChangesOrderInvoice"}
                        UploadDoc={"SalesTools.UploadInvoice"}
                        EditParam1={false}
                        ShowPDFViewer={ShowPDFViewer}
                        user={"user"}
                        Counter={true}
                        MailTools={MailTools}
                        ReportsModel={ReportsModel}
                        printhide={printhide}
                        ShowFormatToPrint={ShowFormatToPrint}
                        reprint={false}
                        downloadCSV={true}
                    />
                }
            </div>
        );
    }
}

export default ReportCreditWalletModal;